// Central state reset for all composables
export function resetAllComposables() {
  // Reset exercises state
  try {
    const useExercises = require('@/composables/api/exercises').default
    const { resetState: resetExercises } = useExercises()
    if (resetExercises) resetExercises()
  } catch (e) {
    console.warn('Could not reset exercises state:', e)
  }

  // Reset sessions state
  try {
    const useSessions = require('@/composables/api/sessions').default
    const { resetState: resetSessions } = useSessions()
    if (resetSessions) resetSessions()
  } catch (e) {
    console.warn('Could not reset sessions state:', e)
  }

  // Reset academies state
  try {
    const useAcademies = require('@/composables/api/academies').default
    const { resetState: resetAcademies } = useAcademies()
    if (resetAcademies) resetAcademies()
  } catch (e) {
    console.warn('Could not reset academies state:', e)
  }

  // Reset files state
  try {
    const useFiles = require('@/composables/api/files').default
    const { resetState: resetFiles } = useFiles()
    if (resetFiles) resetFiles()
  } catch (e) {
    console.warn('Could not reset files state:', e)
  }

  // Reset fitness assessments state
  try {
    const useFitnessAssessments = require('@/composables/api/assessments/fitness').default
    const { resetState: resetFitnessAssessments } = useFitnessAssessments()
    if (resetFitnessAssessments) resetFitnessAssessments()
  } catch (e) {
    console.warn('Could not reset fitness assessments state:', e)
  }

  // Reset golf assessments state
  try {
    const useGolfAssessments = require('@/composables/api/assessments/golf').default
    const { resetState: resetGolfAssessments } = useGolfAssessments()
    if (resetGolfAssessments) resetGolfAssessments()
  } catch (e) {
    console.warn('Could not reset golf assessments state:', e)
  }

  // Reset session assessments state
  try {
    const useSessionAssessments = require('@/composables/api/assessments/session').default
    const { resetState: resetSessionAssessments } = useSessionAssessments()
    if (resetSessionAssessments) resetSessionAssessments()
  } catch (e) {
    console.warn('Could not reset session assessments state:', e)
  }
}
